export const jobStatus = (id, status) => {
    switch(String(id)) {
        case '1':
            return <span className="badge bg-secondary">{status}</span>;
        case '2':
        case '3':
            return <span className="badge bg-info">{status}</span>;
        case '4':
            return <span className="badge bg-warning">{status}</span>;
        case '5':
        case '6':
            return <span className="badge bg-success">{status}</span>;
        default:
            return 'Unknown';
    }
};